import React, { useState, useContext, useEffect } from "react";
import MA_MainMenu from './MA_MainMenu'
import Card from '../../Components/MA/ListCard/Card'
import FilterTag from "../../Components/Tag";
import Table from '../../Components/MA/TableComponent'
import RefineSearch from '../../Components/RefineSearchComponent'
import MALayout from '../../Components/M&ALayout'
import xls from "../../images/xls/png/Group 47.png";
import line from "../../images/line.png";
import moment from "moment";
import FileIcon from "../../images/file.png";
import FileIconBlur from "../../images/fileblur.png";
import MonthPickerComponent from "../../Utils/MonthPickerComponent";
import Constants from '../../Constants'
import ExcelPopup from "../../Components/ExcelPopup";
import SavedFilterContent from "../../Components/SavedFilter";
import { TableDataContext } from '../../Contexts/TableDataContext'
import { maCompanyListExcelExport } from "../../Config/config";
import PdfDownloader from "../../Components/shared/PdfDownloader";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import MaCompaniesRefineSearch from "../../Components/RefineSearch/MaCompaniesRefineSearch";
import { useLocation } from "react-router-dom";
import { UserContext } from "../../Contexts/UserContext";
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { Tooltip } from "antd";
import { FaChartBar } from "react-icons/fa";
import { RiMailDownloadLine } from "react-icons/ri";
import DownloadTrigger from "../../Components/ExportPopup/DownloadTrigger";
import ChartPopup from "../../Components/ChartPopup/ChartPopup";
import axios from "axios";
import { getMaCompaniesApi } from "../../Config/config";
import { getCategoryWiseGlobalSearchIds } from "../../Components/useGlobalSearch";
import FeatureTour from "../../Components/FeatureTour";
/**
 * The MAHome function is a React component that renders a page with a top navigation bar, a filter
 * section, and a table section.
 * @param props - The `props` parameter is an object that contains any properties passed to the
 * `MAHome` component from its parent component. These properties can be accessed using dot notation,
 * such as `props.active` or `props.someProperty`.
 * @returns The MAHome component is being returned.
 */
const MAHome = (props) => {
    const [showExcelPopup, setshowExcelPopup] = useState()
    const location = useLocation();
    const [openTab, setOpenTab] = React.useState(1);
    const { monthPickerValue ,save, setSave,showMonthPicker, refineSearchFilters ,groupId, isMobile,setOpen,open,setIsMobile, accessControl, showChartPopup, setShowChartPopup, dealsView, setDealsView, isChartRedirect} = useContext(PeFilterContext);
    const { getToken, logout, shouldShowFeatureTour, markFeatureTourAsShown } = useContext(UserContext);
    const [showFeatureTour, setShowFeatureTour] = useState(false);
    
    const [date, setDate] = useState([
        moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
        moment().endOf("month").format("YYYY-MM-DD"),
      ]);
    
    // Chart states
    // const [showChartPopup, setShowChartPopup] = useState(false);
    const [currentChartData, setCurrentChartData] = useState(null);
    const [isChartLoading, setIsChartLoading] = useState(false);
    const [currentShowBy, setCurrentShowBy] = useState('');
    const [chartInterval, setChartInterval] = useState('yearly');
    const [chartPeriod, setChartPeriod] = useState('CY');
    
    // let initialMonthRange = null;
    // if (loadPreviousStateRef.current === true) {
    //     initialMonthRange = monthPickerValue;
    //     loadPreviousStateRef.current = false; 
    // } else {
    //     initialMonthRange = Constants.initialMonthRange;
    // }
    // const [date, setDate] = useState(initialMonthRange); 
    // const [save, setSave] = useState(false);
    const savedList = () => {
        setSave(!save)
    }
    useEffect(() => {
        setOpenTab(props.active)
    }, [openTab])
    useEffect(()=>{
    if (window.innerWidth < 800) {
        // setOpen(true);
        setIsMobile(true);
    }
    
    // Check if feature tour should be shown globally (once across all modules)
    if (shouldShowFeatureTour()) {
      // Show tour after a short delay to ensure elements are rendered
      setTimeout(() => {
        setShowFeatureTour(true);
      }, 1000);
    }
    }, [])
    const { totalNoOfCompanies, setTotalNoOfCompanies, tableCompanyId, allDealIds, globalSearchResult, setGlobalSearchResult } = useContext(TableDataContext);
    const { pathname } = useLocation(); 
    console.log(tableCompanyId, 'tableCompanyId');
    const {isStudent} = useContext(UserContext)

    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false

    // Fallback chart data structure in case API data hasn't loaded yet
    const fallbackChartData = {
        "success": true,
        "message": "Loading chart data...",
        "data": {
            "summary": {
                "total_periods": 0,
                "totals": {
                    "deal_count": 0
                },
                "group_totals": {}
            },
            "dataset": []
        }
    };

    // Function to get current show_by value based on applied filters
    const getShowByValue = () => {
        const pathnameFilters = refineSearchFilters[pathname];
        
        // Count how many filters are applied
        const appliedFilters = [];

        appliedFilters.push('year');

        if(isFromGlobalSearch()){
            appliedFilters.push('company')
            return appliedFilters[0]
        }
        
        // Check pathname filters
        if (pathnameFilters?.industry?.length > 0) appliedFilters.push('target_industry');
        if (pathnameFilters?.sector?.length > 0) appliedFilters.push('target_sector');
        if (pathnameFilters?.companyType?.length > 0) appliedFilters.push('target_company_type');
        if (pathnameFilters?.countries?.length > 0) appliedFilters.push('target_country');
        if (pathnameFilters?.region?.length > 0) appliedFilters.push('target_region');
        if (pathnameFilters?.state?.length > 0) appliedFilters.push('target_state');
        if (pathnameFilters?.city?.length > 0) appliedFilters.push('target_city');
        if (pathnameFilters?.dealType?.length > 0) appliedFilters.push('deal_type');

        if (pathnameFilters?.acquirer_industry?.length > 0) appliedFilters.push('acquirer_industry');
        if (pathnameFilters?.acquirerType?.length > 0) appliedFilters.push('acquirer_company_type');
        if (pathnameFilters?.acquirerCountries?.length > 0) appliedFilters.push('acquirer_country');
        if (pathnameFilters?.acquirerRegion?.length > 0) appliedFilters.push('acquirer_region');
        if (pathnameFilters?.acquirerState?.length > 0) appliedFilters.push('acquirer_state');
        if (pathnameFilters?.acquirerCity?.length > 0) appliedFilters.push('acquirer_city');
        
        if (pathnameFilters?.dealRange?.length > 0) appliedFilters.push('deal_range');
        if (pathnameFilters?.valuations?.length > 0) appliedFilters.push('valuation');

        if (pathnameFilters?.target_company?.length > 1) appliedFilters.push('company');
        if (pathnameFilters?.group?.length > 0) appliedFilters.push('company_group');
        if (pathnameFilters?.acquirers?.length > 1) appliedFilters.push('acquirer');
        if (pathnameFilters?.acquirer_group?.length > 0) appliedFilters.push('acquirer_group');
        if (pathnameFilters?.ladvisors?.length > 1) appliedFilters.push('ladvisor');
        if (pathnameFilters?.tadvisors?.length > 1) appliedFilters.push('tadvisor');
        
        // If multiple filters are applied, return the first available filter
        if (appliedFilters.length > 1) {
            return appliedFilters[0];
        }
        
        // If only one filter is applied, return that filter
        if (appliedFilters.length === 1) {
            return appliedFilters[0];
        }
        
        // Default fallback if no filters are applied
        return '';
    };

    // Function to get available filter options based on applied filters
    const getAvailableShowByOptions = () => {
        const pathnameFilters = refineSearchFilters[pathname];
        
        const availableOptions = [];

        availableOptions.push('year');

        if(isFromGlobalSearch()){
            availableOptions.push('company')
            return availableOptions;
        }
        
        // Add filter options based on what's actually applied
        if (pathnameFilters?.industry?.length > 0) availableOptions.push('target_industry');
        if (pathnameFilters?.acquirer_industry?.length > 0) availableOptions.push('acquirer_industry');
        if (pathnameFilters?.sector?.length > 0) availableOptions.push('target_sector');
        if (pathnameFilters?.countries?.length > 0) availableOptions.push('target_country');
        if (pathnameFilters?.acquirerCountries?.length > 0) availableOptions.push('acquirer_country');
        if (pathnameFilters?.region?.length > 0) availableOptions.push('target_region');
        if (pathnameFilters?.acquirerRegion?.length > 0) availableOptions.push('acquirer_region');
        if (pathnameFilters?.state?.length > 0) availableOptions.push('target_state');
        if (pathnameFilters?.acquirerState?.length > 0) availableOptions.push('acquirer_state');
        if (pathnameFilters?.city?.length > 0) availableOptions.push('target_city');
        if (pathnameFilters?.acquirerCity?.length > 0) availableOptions.push('acquirer_city');
        if (pathnameFilters?.companyType?.length > 0) availableOptions.push('target_company_type');
        if (pathnameFilters?.acquirerType?.length > 0) availableOptions.push('acquirer_company_type');
        if (pathnameFilters?.ladvisors?.length > 1) availableOptions.push('ladvisor');
        if (pathnameFilters?.tadvisors?.length > 1) availableOptions.push('tadvisor');
        if (pathnameFilters?.acquirers?.length > 1) availableOptions.push('acquirer');
        if (pathnameFilters?.target_company?.length > 1) availableOptions.push('company');
        if (pathnameFilters?.dealRange?.length > 0) availableOptions.push('deal_range');
        if (pathnameFilters?.dealType?.length > 0) availableOptions.push('deal_type');
        if (pathnameFilters?.valuations?.length > 0) availableOptions.push('valuation');
        if (pathnameFilters?.group?.length > 0) availableOptions.push('company_group');
        if (pathnameFilters?.acquirer_group?.length > 0) availableOptions.push('acquirer_group');

        return availableOptions;
    };

    // Function to fetch chart data when chart icon is clicked
    const handleChartIconClick = async () => {

        try {
            // Calculate and set the current show_by value
            const currentShowByValue = getShowByValue();
            setCurrentShowBy(currentShowByValue);
            
            // Show popup immediately with loading state
            setIsChartLoading(true);
            setCurrentChartData(null);
            setShowChartPopup(true);
            
            // For API call, if multiple filters are applied, use the first available option
            let apiShowByValue = currentShowByValue;
            if (currentShowByValue === 'multiple_filters') {
                const availableOptions = getAvailableShowByOptions();
                apiShowByValue = availableOptions[0] || '';
            }

            // Get IDs for global search if needed
            let companyIds = refineSearchFilters[pathname]?.target_company?.map(company => company.id);
            let globalSearchResults = isFromGlobalSearch () ? await getCategoryWiseGlobalSearchIds(globalSearchResult, setGlobalSearchResult, "merger_acquisition") : {};

            const response = await axios(getMaCompaniesApi, {
                method: "POST",
                data: {
                    date_range: {
                        from_date: moment(monthPickerValue?.[0] || moment().startOf("month").subtract(12, "months")).format("YYYY-MM-DD"),
                        to_date: moment(monthPickerValue?.[1] || moment().endOf("month")).format("YYYY-MM-DD"),
                    },
                    from: isFromGlobalSearch() ? "gs" : "",
                    company_ids: companyIds,
                    acquirer_group: refineSearchFilters[pathname]?.acquirer_group?.map(opt => opt.name),
                    deal_ids: isFromGlobalSearch() ? (globalSearchResults["merger_acquisition"] && globalSearchResults["merger_acquisition"].length > 0 ? globalSearchResults["merger_acquisition"] : []) : [],
                    "acquirer_city": refineSearchFilters[pathname]?.acquirerCity?.map(city => city.id),
                    "acquirer_ids": refineSearchFilters[pathname]?.acquirers?.map(acq => acq.id),
                    "acquirer_company_type": refineSearchFilters[pathname]?.acquirerType?.map(type => type.id),
                    "acquirer_country": refineSearchFilters[pathname]?.acquirerCountries?.map(country => country.id),
                    "company_group": refineSearchFilters[pathname]?.group?.map(group => group.name),
                    "acquirer_region": refineSearchFilters[pathname]?.acquirerRegion?.map(region => region.id),
                    "acquirer_state": refineSearchFilters[pathname]?.acquirerState?.map(state => state.id),
                    "deal_range": refineSearchFilters[pathname]?.dealRange?.at(0) && {
                        "from": refineSearchFilters[pathname]?.dealRange[0].name,
                        "to": refineSearchFilters[pathname]?.dealRange[1].name
                    },
                    "deal_type": refineSearchFilters[pathname]?.dealType?.map(type => type.id),
                    "ladvisor_ids": refineSearchFilters[pathname]?.ladvisors?.map(acq => acq.id),
                    "tadvisor_ids": refineSearchFilters[pathname]?.tadvisors?.map(acq => acq.id),
                    "target_city": refineSearchFilters[pathname]?.city?.length > 0 ? refineSearchFilters[pathname]?.city?.map(
                        (city) => city.id
                    ) : accessControl?.ma_cities?.id,
                    "target_company_type": refineSearchFilters[pathname]?.companyType?.map(type => type.id),
                    "target_country": refineSearchFilters[pathname]?.countries?.length > 0 ? refineSearchFilters[pathname]?.countries?.map(country => country.id) : accessControl?.ma_countries?.id,
                    "target_industry": refineSearchFilters[pathname]?.industry?.length > 0 ? refineSearchFilters[pathname]?.industry?.map(
                        (value) => value.id) : accessControl?.maindustries?.id,
                    "acquirer_industry": refineSearchFilters[pathname]?.acquirer_industry?.length > 0 ? refineSearchFilters[pathname]?.acquirer_industry?.map(
                        (value) => value.id) : accessControl?.maindustries?.id,
                    "target_sector": refineSearchFilters[pathname]?.sector?.map(value => value.name),
                    "target_region": refineSearchFilters[pathname]?.region?.length > 0 ? refineSearchFilters[pathname]?.region?.map(
                        (region) => region.id
                    ) : accessControl?.ma_regions?.id,
                    "target_state": refineSearchFilters[pathname]?.state?.length > 0 ? refineSearchFilters[pathname]?.state?.map(
                        (state) => state.id
                    ) : accessControl?.ma_states?.id,
                    "valuation": refineSearchFilters[pathname]?.valuations?.map(valuation => valuation.value),
                    ...(apiShowByValue && { show_by: apiShowByValue }),
                    interval: chartInterval,
                    period: chartPeriod,
                    isChart: true,
                    view_by: 'both',
                    group: {
                        group_id: groupId?.myList?.map((id) => id.group_id)?.toString() ?? null,
                        sub_type_master_id: groupId?.myList?.length > 0 ? Constants.subCategoryIds.ma_companies_id : null,
                    },
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: getToken(),
                },
            });

            if (response?.data?.success === true && response?.data?.message === "Chart data generated successfully") {
                // Set the fresh chart data for the popup and stop loading
                setCurrentChartData(response.data);
                setIsChartLoading(false);
                
                console.log('Chart data fetched successfully:', response.data);
            } else if (response?.data?.message === "Success") {
                // Fallback for old response format
                const freshChartData = response?.data;
                
                // Set the fresh chart data for the popup and stop loading
                setCurrentChartData(freshChartData);
                setIsChartLoading(false);
                
                console.log('Chart data fetched successfully (legacy format):', freshChartData);
            } else {
                console.error('Unexpected response format:', response?.data);
                setCurrentChartData(fallbackChartData);
                setIsChartLoading(false);
            }
        } catch (error) {
            console.error('Error fetching chart data:', error);
            if (error?.response?.status == Constants.sessionTerminatedStatus 
                || error?.response?.status == Constants.InvalidTokenStatus
            ){
                logout();
            }
            // Show popup with fallback data in case of error and stop loading
            setCurrentChartData(fallbackChartData);
            setIsChartLoading(false);
        }
    };

    const dealsViewHandler = (checked) => {
        setDealsView(checked);
        if (checked) {
            setShowChartPopup(false);
        }
    };

    const chartViewHandler = () => {
        setDealsView(false);
        setShowChartPopup(true);
        handleChartIconClick()
    };

    const ToggleViewButton = () => {
        return (
            <div className="flex rounded-xs border p-0.5 justify-end py-1">
                {dealsView && !showChartPopup ? (
                    <div className="flex bg-white">
                        <div
                            className={`w-14 md:w-24 p-3 py-0 text-xs md:text-sm border-r border-gray-500 ${
                                dealsView ? "bg-[#ad7907] rounded-xs text-white" : "bg-white"
                            } transition-all duration-300 ease-in-out`}
                            >
                            <button><span className="hidden md:inline">Deals View</span><span className="inline md:hidden">Deals</span></button>
                        </div>
                        <Tooltip placement="bottom" title="Switch To Chart View">
                            <div
                                className={`w-14 md:w-24 p-3 py-0 text-xs md:text-sm bg-white hover:bg-gray-50 transition-all duration-200 ease-in-out`}
                            >
                                <button onClick={chartViewHandler} aria-label="chart-view-button"><span className="hidden md:inline">Chart View</span><span className="inline md:hidden">Table</span></button>
                            </div>
                        </Tooltip>
                    </div>
                ) : (
                    <div className="flex bg-white">
                        <Tooltip placement="bottom" title="Switch To Deals View">
                        <div
                            className={`w-14 md:w-24 p-3 py-0 text-xs md:text-sm border-r border-gray-500 bg-white hover:bg-gray-50 transition-all duration-300 ease-in-out`}
                        >
                            <button onClick={() => dealsViewHandler(true)}><span className="hidden md:inline">Deals View</span><span className="inline md:hidden">Deals</span></button>
                        </div>
                        </Tooltip>
                        <div
                        className={`w-14 md:w-24 p-3 py-0 text-xs md:text-sm ${
                            showChartPopup ? "bg-[#ad7907] rounded-xs text-white" : "bg-white"
                        } transition-all duration-300 ease-in-out`}
                        >
                        <button><span className="hidden md:inline">Chart View</span><span className="inline md:hidden">Table</span></button>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    useEffect(() => {
        // Only fetch chart data if we're in chart view
        if (showChartPopup) {
            handleChartIconClick()
        }
    }, [refineSearchFilters[pathname], monthPickerValue, showChartPopup])

    const handlePeriodChange = async (newPeriod) => {
        setChartPeriod(newPeriod);
        setIsChartLoading(true);
        try {
            let companyIds = refineSearchFilters[pathname]?.target_company?.map(company => company.id);
            let globalSearchResults = isFromGlobalSearch() ? await getCategoryWiseGlobalSearchIds(globalSearchResult, setGlobalSearchResult, "merger_acquisition") : {};
            const response = await axios(getMaCompaniesApi, {
                method: "POST",
                data: {
                    date_range: {
                        from_date: moment(monthPickerValue?.[0] || moment().startOf("month").subtract(12, "months")).format("YYYY-MM-DD"),
                        to_date: moment(monthPickerValue?.[1] || moment().endOf("month")).format("YYYY-MM-DD"),
                    },
                    from: isFromGlobalSearch() ? "gs" : "",
                    company_ids: companyIds,
                    acquirer_group: refineSearchFilters[pathname]?.acquirer_group?.map(opt => opt.name),
                    deal_ids: isFromGlobalSearch() ? (globalSearchResults["merger_acquisition"]?.length > 0 ? globalSearchResults["merger_acquisition"] : []) : [],
                    acquirer_city: refineSearchFilters[pathname]?.acquirerCity?.map(city => city.id),
                    acquirer_ids: refineSearchFilters[pathname]?.acquirers?.map(acq => acq.id),
                    acquirer_company_type: refineSearchFilters[pathname]?.acquirerType?.map(type => type.id),
                    acquirer_country: refineSearchFilters[pathname]?.acquirerCountries?.map(country => country.id),
                    company_group: refineSearchFilters[pathname]?.group?.map(group => group.name),
                    acquirer_region: refineSearchFilters[pathname]?.acquirerRegion?.map(region => region.id),
                    acquirer_state: refineSearchFilters[pathname]?.acquirerState?.map(state => state.id),
                    deal_range: refineSearchFilters[pathname]?.dealRange?.at(0) && { from: refineSearchFilters[pathname]?.dealRange[0].name, to: refineSearchFilters[pathname]?.dealRange[1].name },
                    deal_type: refineSearchFilters[pathname]?.dealType?.map(type => type.id),
                    ladvisor_ids: refineSearchFilters[pathname]?.ladvisors?.map(acq => acq.id),
                    tadvisor_ids: refineSearchFilters[pathname]?.tadvisors?.map(acq => acq.id),
                    target_city: refineSearchFilters[pathname]?.city?.length > 0 ? refineSearchFilters[pathname]?.city?.map(c => c.id) : accessControl?.ma_cities?.id,
                    target_company_type: refineSearchFilters[pathname]?.companyType?.map(type => type.id),
                    target_country: refineSearchFilters[pathname]?.countries?.length > 0 ? refineSearchFilters[pathname]?.countries?.map(c => c.id) : accessControl?.ma_countries?.id,
                    target_industry: refineSearchFilters[pathname]?.industry?.length > 0 ? refineSearchFilters[pathname]?.industry?.map(v => v.id) : accessControl?.maindustries?.id,
                    acquirer_industry: refineSearchFilters[pathname]?.acquirer_industry?.length > 0 ? refineSearchFilters[pathname]?.acquirer_industry?.map(v => v.id) : accessControl?.maindustries?.id,
                    target_sector: refineSearchFilters[pathname]?.sector?.map(v => v.name),
                    target_region: refineSearchFilters[pathname]?.region?.length > 0 ? refineSearchFilters[pathname]?.region?.map(r => r.id) : accessControl?.ma_regions?.id,
                    target_state: refineSearchFilters[pathname]?.state?.length > 0 ? refineSearchFilters[pathname]?.state?.map(s => s.id) : accessControl?.ma_states?.id,
                    valuation: refineSearchFilters[pathname]?.valuations?.map(v => v.value),
                    ...(currentShowBy && { show_by: currentShowBy }),
                    interval: chartInterval,
                    period: newPeriod,
                    isChart: true,
                    view_by: 'both',
                    group: { group_id: groupId?.myList?.map(id => id.group_id)?.toString() ?? null, sub_type_master_id: groupId?.myList?.length > 0 ? Constants.subCategoryIds.ma_companies_id : null },
                },
                headers: { "Content-Type": "application/json", Authorization: getToken() },
            });
            if (response?.data?.success === true && response?.data?.message === "Chart data generated successfully") {
                setCurrentChartData(response.data);
            } else {
                setCurrentChartData(fallbackChartData);
            }
        } catch (error) {
            console.error('Error fetching chart data:', error);
            setCurrentChartData(fallbackChartData);
        } finally {
            setIsChartLoading(false);
        }
    };

    const handleIntervalChange = async (newInterval) => {
        setChartInterval(newInterval);
        setIsChartLoading(true);
        try {
            let companyIds = refineSearchFilters[pathname]?.target_company?.map(company => company.id);
            let globalSearchResults = isFromGlobalSearch() ? await getCategoryWiseGlobalSearchIds(globalSearchResult, setGlobalSearchResult, "merger_acquisition") : {};
            const response = await axios(getMaCompaniesApi, {
                method: "POST",
                data: {
                    date_range: {
                        from_date: moment(monthPickerValue?.[0] || moment().startOf("month").subtract(12, "months")).format("YYYY-MM-DD"),
                        to_date: moment(monthPickerValue?.[1] || moment().endOf("month")).format("YYYY-MM-DD"),
                    },
                    from: isFromGlobalSearch() ? "gs" : "",
                    company_ids: companyIds,
                    acquirer_group: refineSearchFilters[pathname]?.acquirer_group?.map(opt => opt.name),
                    deal_ids: isFromGlobalSearch() ? (globalSearchResults["merger_acquisition"]?.length > 0 ? globalSearchResults["merger_acquisition"] : []) : [],
                    acquirer_city: refineSearchFilters[pathname]?.acquirerCity?.map(city => city.id),
                    acquirer_ids: refineSearchFilters[pathname]?.acquirers?.map(acq => acq.id),
                    acquirer_company_type: refineSearchFilters[pathname]?.acquirerType?.map(type => type.id),
                    acquirer_country: refineSearchFilters[pathname]?.acquirerCountries?.map(country => country.id),
                    company_group: refineSearchFilters[pathname]?.group?.map(group => group.name),
                    acquirer_region: refineSearchFilters[pathname]?.acquirerRegion?.map(region => region.id),
                    acquirer_state: refineSearchFilters[pathname]?.acquirerState?.map(state => state.id),
                    deal_range: refineSearchFilters[pathname]?.dealRange?.at(0) && { from: refineSearchFilters[pathname]?.dealRange[0].name, to: refineSearchFilters[pathname]?.dealRange[1].name },
                    deal_type: refineSearchFilters[pathname]?.dealType?.map(type => type.id),
                    ladvisor_ids: refineSearchFilters[pathname]?.ladvisors?.map(acq => acq.id),
                    tadvisor_ids: refineSearchFilters[pathname]?.tadvisors?.map(acq => acq.id),
                    target_city: refineSearchFilters[pathname]?.city?.length > 0 ? refineSearchFilters[pathname]?.city?.map(c => c.id) : accessControl?.ma_cities?.id,
                    target_company_type: refineSearchFilters[pathname]?.companyType?.map(type => type.id),
                    target_country: refineSearchFilters[pathname]?.countries?.length > 0 ? refineSearchFilters[pathname]?.countries?.map(c => c.id) : accessControl?.ma_countries?.id,
                    target_industry: refineSearchFilters[pathname]?.industry?.length > 0 ? refineSearchFilters[pathname]?.industry?.map(v => v.id) : accessControl?.maindustries?.id,
                    acquirer_industry: refineSearchFilters[pathname]?.acquirer_industry?.length > 0 ? refineSearchFilters[pathname]?.acquirer_industry?.map(v => v.id) : accessControl?.maindustries?.id,
                    target_sector: refineSearchFilters[pathname]?.sector?.map(v => v.name),
                    target_region: refineSearchFilters[pathname]?.region?.length > 0 ? refineSearchFilters[pathname]?.region?.map(r => r.id) : accessControl?.ma_regions?.id,
                    target_state: refineSearchFilters[pathname]?.state?.length > 0 ? refineSearchFilters[pathname]?.state?.map(s => s.id) : accessControl?.ma_states?.id,
                    valuation: refineSearchFilters[pathname]?.valuations?.map(v => v.value),
                    ...(currentShowBy && { show_by: currentShowBy }),
                    interval: newInterval,
                    period: chartPeriod,
                    isChart: true,
                    view_by: 'both',
                    group: { group_id: groupId?.myList?.map(id => id.group_id)?.toString() ?? null, sub_type_master_id: groupId?.myList?.length > 0 ? Constants.subCategoryIds.ma_companies_id : null },
                },
                headers: { "Content-Type": "application/json", Authorization: getToken() },
            });
            if (response?.data?.success === true && response?.data?.message === "Chart data generated successfully") {
                setCurrentChartData(response.data);
            } else {
                setCurrentChartData(fallbackChartData);
            }
        } catch (error) {
            console.error('Error fetching chart data:', error);
            setCurrentChartData(fallbackChartData);
        } finally {
            setIsChartLoading(false);
        }
    };

    console.log(globalSearchResult["merger_acquisition"], "ma gs result")

    const exportData = {
        "date_range": {
            "from_date": monthPickerValue[0],
            "to_date": monthPickerValue[1]
        },
        "company_id": tableCompanyId,
        "deal_ids":allDealIds,
        type: 4
    }

    return (
        <div>
            <MALayout menu="ma">
                <div className="flex min-h-screen h-screen flex-col">
                    {/* Top nav*/}
                    <div className={`transition-all duration-500 ease-in-out ${showChartPopup ? 'opacity-0 -translate-y-4 h-0 overflow-hidden' : 'opacity-100 translate-y-0'}`}>
                        {!showChartPopup && <Card menu="ma" />}
                    </div>
    
                    {/* Bottom section */}
                    <div className={`transition-all duration-500 ease-in-out ${showChartPopup ? "mt-12" : ""} flex min-h-0 flex-1 overflow-hidden`}>
                        {/* Narrow sidebar*/}
                        {/* Main area */}
                        <main className="min-w-0 flex-1 border-t border-gray-200 flex">
                            {/* Primary column */}
                            <section className="flex h-full min-w-0 flex-1 flex-col lg:order-last bg-[#EDEDED] pt-2">

                                {/* Your content */}
                                {isMobile ? (<FilterTag />) : null }
                                <div className="ml-3 mx-4 mt-1 rounded-t-md bg-white flex items-center justify-between ">
                                <div className=" pr-4 lg:pr-4 md:pr-[0.7rem] w-[100%]">                                   
                                        <div className="rounded-[6px] rounded-b-none block lg:flex flex-row justify-between  ">
                                            {/* <MA_MainMenu active={1} menu="ma" primaryTypeMasterId={Constants.primaryMasterIds.mANDaId}
                                                typeId={Constants.moduleIds.companiesId}/> */}
                                            {!isMobile ? (<div className="mt-1">
                                                <FilterTag />  
                                            </div>) : null }
                                            <div className={"justify-between items-center px-2 py-2 space-x-4 "+(showMonthPicker!=0 ? 'md:flex':'flex')}>
                                                {!isChartRedirect && ToggleViewButton()}
                                                <label htmlFor="" className="text-[#666666] ">
                                                    <div className={showMonthPicker!=0 ?"":'flex'}>
                                                        <MonthPickerComponent  />
                                                    </div>
                                                </label>

                                                <div className={showMonthPicker!=0 ?"hidden md:flex space-x-3":"flex space-x-3"}>   
                                                    {/* <button
                                                    className="cursor-pointer mt-2"
                                                    onClick={() => setOpen(!open)}
                                                    aria-label="filter-button"
                                                    >
                                                        <FaFilter color="#bc8b20" size={21} />
                                                    </button> */}
                                                    <a>
                                                        <img
                                                            className="h-[24px] max-w-[2px] mt-1 "
                                                            src={line}
                                                        />
                                                    </a>
                                                {isStudent === 'true' || showChartPopup ? <></> : <>                                                                       
                                                        <PdfDownloader
                                                            url={maCompanyListExcelExport}
                                                            type="xlsx"                                                            
                                                            fileName={Constants.exportNames.ma_list}

                                                            data={exportData}
                                                        >
                                                            <DownloadTrigger />
                                                        </PdfDownloader>
                                                    
                                                        {groupId?.myList?.length >0 ?<></>:<a>
                                                        <img className="h-[24px] w-[2px] mt-1 " src={line} />
                                                    </a>}
                                                </>}
                                                
                                                    <a className="group cursor-pointer">
                                                        <div className="cursor-pointer" onClick={savedList}>
                                                            <img src={save ? FileIcon : FileIconBlur}
                                                                className="h-[24px]  w-[21px]"
                                                                alt="" />
                                                        </div>
                                                    </a>
                                                    
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                        {save ? <SavedFilterContent
                                            primaryTypeMasterId={Constants.primaryMasterIds.mANDaId}
                                            subTypeMasterId={Constants.primaryMasterSubIds.ma_companies_id}
                                            typeId={Constants.moduleIds.companiesId}
                                            show={save} 
                                            exportPayload={exportData} /> : ''}
                                            
                                            
                                    </div>
                                </div>
                                <div className='overflow-y-auto h-full'>
                                    {!showChartPopup ? <Table menu="ma" sub_type_master_id={Constants.subCategoryIds.ma_companies_id}/>
                                        : <ChartPopup
                                            isOpen={showChartPopup}
                                            onClose={() => {
                                                setShowChartPopup(false);
                                                setIsChartLoading(false);
                                                setCurrentChartData(null);
                                            }}
                                            data={currentChartData || fallbackChartData}
                                            isLoading={isChartLoading}
                                            showBy={currentShowBy}
                                            availableShowByOptions={getAvailableShowByOptions()}
                                            menuType="ma"
                                            subType="M&A Companies"
                                            interval={chartInterval}
                                            onIntervalChange={handleIntervalChange}
                                            period={chartPeriod}
                                            onPeriodChange={handlePeriodChange}
                                            onShowByChange={async (newShowBy) => {
                                                setCurrentShowBy(newShowBy);
                                                setIsChartLoading(true);
                                                
                                                // Re-fetch data with new show_by value
                                                try {
                                                    const currentShowByValue = newShowBy;
                                                    
                                                    // Get IDs for global search if needed
                                                    let companyIds = refineSearchFilters[pathname]?.target_company?.map(company => company.id);
                                                    let globalSearchResults = isFromGlobalSearch () ? await getCategoryWiseGlobalSearchIds(globalSearchResult, setGlobalSearchResult, "merger_acquisition") : {};

                                                    const response = await axios(getMaCompaniesApi, {
                                                        method: "POST",
                                                        data: {
                                                            date_range: {
                                                                from_date: moment(monthPickerValue?.[0] || moment().startOf("month").subtract(12, "months")).format("YYYY-MM-DD"),
                                                                to_date: moment(monthPickerValue?.[1] || moment().endOf("month")).format("YYYY-MM-DD"),
                                                            },
                                                            from: isFromGlobalSearch() ? "gs" : "",
                                                            company_ids: companyIds,
                                                            acquirer_group: refineSearchFilters[pathname]?.acquirer_group?.map(opt => opt.name),
                                                            deal_ids: isFromGlobalSearch() ? (globalSearchResults["merger_acquisition"] && globalSearchResults["merger_acquisition"].length > 0 ? globalSearchResults["merger_acquisition"] : []) : [],
                                                            "acquirer_city": refineSearchFilters[pathname]?.acquirerCity?.map(city => city.id),
                                                            "acquirer_ids": refineSearchFilters[pathname]?.acquirers?.map(acq => acq.id),
                                                            "acquirer_company_type": refineSearchFilters[pathname]?.acquirerType?.map(type => type.id),
                                                            "acquirer_country": refineSearchFilters[pathname]?.acquirerCountries?.map(country => country.id),
                                                            "company_group": refineSearchFilters[pathname]?.group?.map(group => group.name),
                                                            "acquirer_region": refineSearchFilters[pathname]?.acquirerRegion?.map(region => region.id),
                                                            "acquirer_state": refineSearchFilters[pathname]?.acquirerState?.map(state => state.id),
                                                            "deal_range": refineSearchFilters[pathname]?.dealRange?.at(0) && {
                                                                "from": refineSearchFilters[pathname]?.dealRange[0].name,
                                                                "to": refineSearchFilters[pathname]?.dealRange[1].name
                                                            },
                                                            "deal_type": refineSearchFilters[pathname]?.dealType?.map(type => type.id),
                                                            "ladvisor_ids": refineSearchFilters[pathname]?.ladvisors?.map(acq => acq.id),
                                                            "tadvisor_ids": refineSearchFilters[pathname]?.tadvisors?.map(acq => acq.id),
                                                            "target_city": refineSearchFilters[pathname]?.city?.length > 0 ? refineSearchFilters[pathname]?.city?.map(
                                                                (city) => city.id
                                                            ) : accessControl?.ma_cities?.id,
                                                            "target_company_type": refineSearchFilters[pathname]?.companyType?.map(type => type.id),
                                                            "target_country": refineSearchFilters[pathname]?.countries?.length > 0 ? refineSearchFilters[pathname]?.countries?.map(country => country.id) : accessControl?.ma_countries?.id,
                                                            "target_industry": refineSearchFilters[pathname]?.industry?.length > 0 ? refineSearchFilters[pathname]?.industry?.map(
                                                                (value) => value.id) : accessControl?.maindustries?.id,
                                                            "acquirer_industry": refineSearchFilters[pathname]?.acquirer_industry?.length > 0 ? refineSearchFilters[pathname]?.acquirer_industry?.map(
                                                                (value) => value.id) : accessControl?.maindustries?.id,
                                                            "target_sector": refineSearchFilters[pathname]?.sector?.map(value => value.name),
                                                            "target_region": refineSearchFilters[pathname]?.region?.length > 0 ? refineSearchFilters[pathname]?.region?.map(
                                                                (region) => region.id
                                                            ) : accessControl?.ma_regions?.id,
                                                            "target_state": refineSearchFilters[pathname]?.state?.length > 0 ? refineSearchFilters[pathname]?.state?.map(
                                                                (state) => state.id
                                                            ) : accessControl?.ma_states?.id,
                                                            "valuation": refineSearchFilters[pathname]?.valuations?.map(valuation => valuation.value),
                                                            ...(currentShowByValue && { show_by: currentShowByValue }),
                                                            interval: chartInterval,
                                                            period: chartPeriod,
                                                            isChart: true,
                                                            view_by: 'both',
                                                            group: {
                                                                group_id: groupId?.myList?.map((id) => id.group_id)?.toString() ?? null,
                                                                sub_type_master_id: groupId?.myList?.length > 0 ? Constants.subCategoryIds.ma_companies_id : null,
                                                            },
                                                        },
                                                        headers: {
                                                            "Content-Type": "application/json",
                                                            Authorization: getToken(),
                                                        },
                                                    });

                                                    if (response?.data?.success === true && response?.data?.message === "Chart data generated successfully") {
                                                        setCurrentChartData(response.data);
                                                        setIsChartLoading(false);
                                                    } else if (response?.data?.message === "Success") {
                                                        setCurrentChartData(response?.data);
                                                        setIsChartLoading(false);
                                                    } else {
                                                        console.error('Unexpected response format:', response?.data);
                                                        setCurrentChartData(fallbackChartData);
                                                        setIsChartLoading(false);
                                                    }
                                                } catch (error) {
                                                    console.error('Error re-fetching chart data:', error);
                                                    setCurrentChartData(fallbackChartData);
                                                    setIsChartLoading(false);
                                                }
                                            }}
                                            redirectPath={pathname}
                                        />}
                                </div>
                            </section>
                            {/* Secondary column (hidden on smaller screens) */}
                            <aside className="order-first block flex-shrink-0">
                                <div className="relative flex h-full  flex-col border-r border-gray-200 bg-[#FAF5EA]">
                                    {/* Your content */}
                                    <RefineSearch>
                                        <MaCompaniesRefineSearch customPathname={location.pathname} />
                                    </RefineSearch>
                                </div>
                            </aside>
                        </main>
                    </div>

                </div>
            </MALayout>
            
            {/* Feature Tour */}
            {showFeatureTour && (
                <FeatureTour onClose={() => {
                    markFeatureTourAsShown();
                    setShowFeatureTour(false);
                }} />
            )}
        </div>
    )
}

export default MAHome
